import {
  Calendar,
  Home,
  Settings,
  LogOut,
  File,
  Paperclip,
  User,
  CheckCircle,
  Bookmark,
  Book,
  Clock,
  Repeat,
} from "react-feather";
import { FEATURE_SELECTION, PERMISSIONS } from "../../Constant/FeatureSelection";
import { isAdmin } from "../../Utils/externalFunctions"; 

export const MENUITEMS = [];

const initializeMenu = (checkPermission) => {
  MENUITEMS.length = 0;

  checkPermission(PERMISSIONS.VIEW_DASHBOARD) && FEATURE_SELECTION.includes("Dashboard") &&
    MENUITEMS.push({
      menutitle: "Dashboard",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/dashboard`,
          icon: Home,
          title: "Dashboard",
          type: "link",
        },
      ],
    });

  checkPermission(PERMISSIONS.VIEW_STAF) && FEATURE_SELECTION.includes("Staf") &&
    MENUITEMS.push({
      menutitle: "Staf",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/staff`,
          icon: User,
          title: "Staf",
          type: "link",
        },
      ],
    });

  checkPermission(PERMISSIONS.VIEW_TANDA_TERIMA) && FEATURE_SELECTION.includes("Tanda Terima") &&
    MENUITEMS.push({
      menutitle: "Tanda Terima",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/tandaterima`,
          icon: File,
          title: "Tanda Terima",
          type: "link",
        },
      ],
    });

  checkPermission(PERMISSIONS.ADD_SLIP_GAJI) && FEATURE_SELECTION.includes("Slip Gaji") &&
    MENUITEMS.push({
      menutitle: "Slip Gaji",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/slipgaji`,
          icon: Paperclip,
          title: "Slip Gaji",
          type: "link",
        },
      ],
    });

  checkPermission(PERMISSIONS.VIEW_ABSENSI) && FEATURE_SELECTION.includes("Absen") &&
    MENUITEMS.push({
      menutitle: "Absen",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/absen`,
          icon: CheckCircle,
          title: "Absen",
          type: "link",
        },
      ],
    });

  (checkPermission(PERMISSIONS.VIEW_CUTI) || checkPermission(PERMISSIONS.VIEW_DALAM_PROSES_CUTI) || checkPermission(PERMISSIONS.VIEW_REKAP_CUTI)) && FEATURE_SELECTION.includes("Cuti") &&
    MENUITEMS.push({
      menutitle: "Cuti",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/cuti`,
          icon: Clock,
          title: "Cuti",
          type: "link",
        },
      ],
    });

  checkPermission(PERMISSIONS.VIEW_DOKUMEN) && FEATURE_SELECTION.includes("Dokumen") &&
    MENUITEMS.push({
      menutitle: "Dokumen",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/Dokumen`,
          icon: Book,
          title: "Dokumen",
          type: "link",
        },
      ],
    });

  checkPermission(PERMISSIONS.VIEW_KALENDER) && FEATURE_SELECTION.includes("Kalender") &&
    MENUITEMS.push({
      menutitle: "Kalender",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/kalender`,
          icon: Calendar,
          title: "Kalender",
          type: "link",
        },
      ],
    });

  checkPermission(PERMISSIONS.VIEW_SHIFT) && FEATURE_SELECTION.includes("Shift") &&
    MENUITEMS.push({
      menutitle: "Shift",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/Shift`,
          icon: Repeat,
          title: "Shift",
          type: "link",
        },
      ],
    });

  const settingsItems = [
    checkPermission(PERMISSIONS.VIEW_PENGATURAN_UNIT_KERJA) && FEATURE_SELECTION.includes("Pengaturan Unit Kerja") && {
      path: `${process.env.PUBLIC_URL}/pengaturanunitkerja`,
      title: "Pengaturan Unit Kerja",
      type: "link",
    },
    checkPermission(PERMISSIONS.VIEW_PENGATURAN_TIPE_ABSENSI) && FEATURE_SELECTION.includes("Pengaturan Tipe Absensi") && {
      path: `${process.env.PUBLIC_URL}/pengaturantipeabsensi`,
      title: "Pengaturan Tipe Absensi",
      type: "link",
    },
    checkPermission(PERMISSIONS.VIEW_PENGATURAN_STATUS_STAF) && FEATURE_SELECTION.includes("Pengaturan Status Staf") && {
      path: `${process.env.PUBLIC_URL}/pengaturanstatusstaf`,
      title: "Pengaturan Status Staf",
      type: "link",
    },
    checkPermission(PERMISSIONS.VIEW_PENGATURAN_GROUP_STAF) && FEATURE_SELECTION.includes("Pengaturan Group Staf") && {
      path: `${process.env.PUBLIC_URL}/pengaturangroupstaf`,
      title: "Pengaturan Group Staf",
      type: "link",
    },
    checkPermission(PERMISSIONS.VIEW_PENGATURAN_SLIP_GAJI) && FEATURE_SELECTION.includes("Pengaturan Slip Gaji") && {
      path: `${process.env.PUBLIC_URL}/pengaturanslipgaji`,
      title: "Pengaturan Slip Gaji",
      type: "link",
    },
    checkPermission(PERMISSIONS.VIEW_PENGATURAN_ADMIN) && FEATURE_SELECTION.includes("Pengaturan Admin") && {
      path: `${process.env.PUBLIC_URL}/pengaturanadmin`,
      title: "Pengaturan Admin",
      type: "link",
    },
    checkPermission(PERMISSIONS.VIEW_PENGATURAN_KURIR) && FEATURE_SELECTION.includes("Pengaturan Kurir") && {
      path: `${process.env.PUBLIC_URL}/pengaturankurir`,
      title: "Pengaturan Kurir",
      type: "link",
    },
  ].filter(Boolean);

  if (FEATURE_SELECTION.includes("Pengaturan") && isAdmin && settingsItems.length > 0) {
    MENUITEMS.push({
      menutitle: "Pengaturan",
      Items: [
        {
          title: "Pengaturan",
          icon: Settings,
          type: "sub",
          active: false,
          children: settingsItems,
        },
      ],
    });
  }

  FEATURE_SELECTION.includes("Panduan") &&
    MENUITEMS.push({
      menutitle: "Panduan",
      Items: [
        {
          path: `${process.env.PUBLIC_URL}/panduan`,
          icon: Bookmark,
          title: "Panduan",
          type: "link",
        },
      ],
    });

  MENUITEMS.push({
    menutitle: "Log Out",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/login`,
        icon: LogOut,
        title: "Log Out",
        type: "link",
      },
    ],
  });
};


export { initializeMenu };